require.register("export/controllers/documentCtrl", function(exports, require, module){
  $0
  
});

